// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1c9ol","actions":"GroupTable_actions__19Q2K","deleteModalFooter":"GroupTable_deleteModalFooter__12jZZ"};